module.exports = __webpack_public_path__ + "media/img/uploads/event-featured-thumb-05-459f036e7194dae715ce1f7fce8c067c.jpg";